export default "__VITE_ASSET__CvSHHof1__"